import { Breadcrumbs } from '@mui/material';
import Util from '../Util';

function TimeFrameDates(props: { from: Date; to: Date; isShortFormat?: boolean }) {
    const formatFunc = props.isShortFormat ? Util.formatShortDate : Util.formatLongDate;
    return (
        <Breadcrumbs separator="-" className="ConfigTimeframeText">
            {formatFunc(new Date(props.from))}
            {formatFunc(new Date(props.to))}
        </Breadcrumbs>
    );
}

export default TimeFrameDates;
